import React from "react";
import LinearSelector from "../token/LinearSelector";
import ButtonSelector from "../token/ButtonSelector";
import { useNavigate } from "react-router-dom";
import { useTaxonomies } from "../../hooks/useTaxonomies";

export type TypeOption = "Script" | "Vidéos" | "Styleframes" | "Brands" | "Studios";
/** An industry from the CMS taxonomies, or "All". */
export type CategoryOption = string;

interface DiscoverFiltersProps {
  title: string;
  selectedType: TypeOption;
  setSelectedType: (type: TypeOption) => void;
  selectedCategory: CategoryOption;
  setSelectedCategory: (category: CategoryOption) => void;
  /** Hide the industry chips (brands/studios listings don't use them). */
  showCategories?: boolean;
}

const DiscoverFilters: React.FC<DiscoverFiltersProps> = ({
  title,
  selectedType,
  setSelectedType,
  selectedCategory,
  setSelectedCategory,
  showCategories = true,
}) => {
  const navigate = useNavigate();
  const { taxonomies } = useTaxonomies();

  return (
    <div className="max-w-[100vw] mx-auto px-4 py-8 flex flex-col gap-5">
      <h1 className="font-bold text-5xl">{title}</h1>
      <LinearSelector
        options={["Vidéos", "Brands", "Studios"] as TypeOption[]}
        selected={selectedType}
        setSelected={setSelectedType}
        onSelect={(option) => {
          if (option === "Vidéos") navigate("/");
          else if (option === "Brands") navigate("/brands");
          else if (option === "Studios") navigate("/studios");
        }}
      />
      {showCategories && (
        <ButtonSelector
          options={["All", ...taxonomies.industries]}
          selectedItems={selectedCategory}
          handleToggle={(item: string) => setSelectedCategory(item)}
          filterButton={false}
        />
      )}
    </div>
  );
};

export default DiscoverFilters;
